import React from "react";

import ImageEmbedPreview from "@/Components/ImageEmbedPreview";
import GiphyEmbedPreview from "@/Components/GiphyEmbedPreview";
import YoutubeEmbedPreview from "@/Components/YouTubePreview";

const LinkPreview = ({
    href,
    imageUrl,
    youtubeId,
    portrait,
    title,
    description,
    giphyImageUrl,
    youtubeImageUrl,
    setData,
}) => {
    const previewOptions = {
        href,
        imageUrl,
        youtubeId,
        portrait,
        title,
        description,
        giphyImageUrl,
        youtubeImageUrl,
    };

    if (imageUrl) {
        return (
            <ImageEmbedPreview
                previewOptions={previewOptions}
                setData={setData}
            />
        );
    } else if (youtubeId) {
        return (
            <YoutubeEmbedPreview
                previewOptions={previewOptions}
                setData={setData}
            />
        );
    } else if (giphyImageUrl) {
        return (
            <GiphyEmbedPreview
                previewOptions={previewOptions}
                setData={setData}
            />
        );
    } else {
        return null;
    }
};

export default LinkPreview;
